import html2canvas from "html2canvas";

//  ========= Get Age Dropdown Array =========
export const getAgeInRange = (min, max) => {
  const age = [];
  for (let i = min; i <= max; i++) {
    age.push({
      code: i,
      display_name: `${i === 1 ? `${i} year` : `${i} years`}`,
    });
  }
  return age;
};

export const getChildAgeInRange = (min, max) => {
  const childAge = [];

  for (let i = min; i <= max; i++) {
    if (i === 0) {
      childAge.push({
        code: 0,
        display_name: "6 M - 1 < Yr",
      });
    } else {
      childAge.push({
        code: i,
        display_name: `${i} years`,
      });
    }
  }
  return childAge;
};
//  ========= HTML to JPEG conversion =========
export const printImageById = async (id) => {
  const input = document.getElementById(id);
  const canvas = await html2canvas(input, {
    useCORS: true,
    allowTaint: false,
    scrollX: 0,
    scrollY: -window.scrollY,
  });
  const imgData = canvas.toDataURL("image/jpeg");
  return imgData;
};
//  ========= file to base64 conversion =========
export const convertToBase64 = (file) => {
  if (typeof file === "string") return file;
  if (!file) return "";
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => resolve(fileReader.result);
    fileReader.onerror = (error) => reject(error);
  });
};
//  ========= Care Payment Form =========
export const carePayment = (proposalNum, enquiry_id) => {
  const careForm = document.createElement("form");
  careForm.action = `https://apiuat.religarehealthinsurance.com/portalui/PortalPayment.run`;
  careForm.method = "post";
  careForm.target = "_self";
  careForm.style.display = "none";
  const input1 = document.createElement("input");
  input1.name = "proposalNum";
  input1.type = "hidden";
  input1.value = proposalNum;
  careForm.appendChild(input1);
  const input2 = document.createElement("input");
  input2.name = "returnURL";
  input2.type = "hidden";
  input2.value =
    process.env.REACT_APP_API_BASE_URL +
    `religare-verify-payment?enquiry_id=${enquiry_id}`;
  careForm.appendChild(input2);
  document.body.appendChild(careForm);
  careForm.submit();
  document.body.removeChild(careForm);
  return;
};
